/**
     * Usage:
     * <update-time
     *  time="600000"
     *  format=""
     *  timeTranslateResource="cw.device.status.offline"
     *  timeTranslateValues="{status: '{{device.attributes.last_online | formatTime}}'}">
     * </update-time>
     * Result:
     * <update-time>10 minutes ago</update-time>
     *
     * Note that the directive keeps a timer that updates the minutes passed in real time.
     */

angular.module('directives')
    .directive('updateTime', ($filter, $timeout, Util, $interval) => (
        {
            restrict: 'E',
            replace: true,
            template: '<span ng-bind="translatedTime" connectqa-famloc="last-located"></span>',
            scope: {
                time: '=',
                format: '@format',
                timeTranslateResource: '@timeTranslateResource',
                timeTranslateValues: '@timeTranslateValues',
            },
            /**
                 * General algorithm:
                 * initialize the start time and a timer
                 * on each timer tick compute the difference
                 * between the current time and the start time and display it
                 */
            link(scope) {

                let intervalId;
                let start;

                const showTime = (elapsed) => {

                    if (!scope.timeTranslateResource) {

                        scope.translatedTime = $filter('formatTime')(elapsed, null, null, scope.format);

                    } else {

                        scope.translatedTime = $filter('translate')(
                            scope.timeTranslateResource,
                            scope.timeTranslateValues || {},
                        );

                    }

                };

                const onTick = () => {

                    const elapsed = Date.now() - start;
                    showTime(elapsed);

                };
                const init = () => {

                    const elapsed = Util.getElapsedMilli(scope.time);

                    // current time - time elapsed since the updateTime directive started counting
                    start = Date.now() - elapsed;

                    showTime(elapsed);

                    $interval.cancel(intervalId);
                    intervalId = $interval(onTick, 10 * 100);

                };

                scope.$watch('time', init);

                scope.$on('$destroy', () => {

                    $interval.cancel(intervalId);

                });

            },
        }
    ));



// WEBPACK FOOTER //
// ./scripts/common/directives/updateTime.js